import Flex from 'components/priority/Flex/Flex'
import Text from 'components/priority/Text/Text'

export const LoadingInsertImages = ({ type }) => (
  <Flex margin="0 0 48px 0" height="100%" center>
    <Text color="gray3">Loading {type || 'images'}...</Text>
  </Flex>
)

export default LoadingInsertImages
